import { createTheme } from '@mui/material/styles';

// ──────────────────────────────────────────────
// Centralized color tokens
// Update these values to change colors app-wide.
// ──────────────────────────────────────────────
export const colors = {
  // Brand / Primary
  primary: {
    main: '#294A66',
    dark: '#0f3c71',
    light: '#5CA8E6',
  },

  // Secondary / Action blue
  secondary: {
    main: '#237AB8',
    dark: '#1B6199',
    light: '#93C3F0',
  },

  // Neutrals / Greys
  grey: {
    50: '#FAFAFA',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#374151',
    700: '#1F2937',
    formBg: '#f0f0f0',
    formBorder: '#e0e0e0',
  },

  // Warning / Amber
  warning: {
    main: '#ff9800',
    dark: '#f57c00',
    light: '#fff8e1',
    border: '#ffca28',
    icon: '#f9a825',
    brownTitle: '#5d4037',
    brownSubtitle: '#6d4c41',
  },

  // Alert / Info Yellow
  alert: {
    background: '#ffffe0',
    border: '#fff9c4',
  },

  // Error / Danger
  error: {
    main: '#FF5252',
    reject: '#ff1744',
  },

  // Success
  success: {
    main: '#00e676',
  },

  // Dropzone
  dropzone: {
    border: '#5AA5E9',
    background: '#EDF6FF',
    focus: '#2196f3',
  },

  // Links (Bootstrap-style)
  link: {
    main: '#0d6efd',
    hover: '#0a58ca',
    footer: '#a4cbeb',
  },

  // Backdrop / Overlay
  backdrop: {
    main: '#00000080',
    disabled: 'rgba(0, 0, 0, 0.38)',
    shadow: 'rgba(0,0,0,0.12)',
    shadowMd: 'rgba(0,0,0,0.25)',
  },

  // Common
  white: '#FFFFFF',
  black: '#000000',
};

const customTheme = createTheme({
  palette: {
    primary: {
      main: colors.primary.main,
      dark: colors.primary.dark,
      light: colors.primary.light,
    },
    secondary: {
      main: colors.secondary.main,
      dark: colors.secondary.dark,
      light: colors.secondary.light,
    },
    error: {
      main: colors.error.main,
    },
    warning: {
      main: colors.warning.main,
      dark: colors.warning.dark,
      light: colors.warning.light,
    },
    success: {
      main: colors.success.main,
    },
    grey: {
      50: colors.grey[50],
      100: colors.grey[100],
      200: colors.grey[200],
      300: colors.grey[300],
      400: colors.grey[400],
      500: colors.grey[500],
      600: colors.grey[600],
      700: colors.grey[700],
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 375,
      md: 768,
      lg: 1366,
      xl: 1920,
    },
  },
  components: {
    MuiSpeedDialAction: {
      styleOverrides: {
        staticTooltipLabel: {
          fontSize: '0.9rem',
          fontWeight: 'bold',
          color: 'white',
          backgroundColor: '#000000BB',
          padding: '0px 10px 0px 10px',
          marginTop: '0.125rem',
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: colors.primary.light,
        },
      },
    },
  },
});

export default customTheme;
